export enum ExportTasksFilterState {
    INCLUDE_ANNOTATION = 'INCLUDE_ANNOTATION',
    INCLUDE_DOCUMENTS_NAMES = 'INCLUDE_DOCUMENTS_NAMES',
    INCLUDE_SECTION_NAMES = 'INCLUDE_SECTION_NAMES',
    INCLUDE_DUEDATES = 'INCLUDE_DUEDATES',
}
